import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import subscriptionProductService from "services/subscriptionProductService";

export const getProducts = createAsyncThunk(
	"vino/subscription/getProducts",
	async () => {
		const products = await subscriptionProductService.getProducts();
		return products;
	}
);

export const getCollections = createAsyncThunk(
	"vino/subscription/getCollections",
	async () => {
		const collections = await subscriptionProductService.getCollections();
		return collections;
	}
);

const subscriptionProductsSlice = createSlice({
	name: "vino/subscription-products",
	initialState: {
		products: [],
		collections: [],
	},
	reducers: {
		resetState: (state) => {
			state.products = [];
			state.collections = [];
		},
	},

	extraReducers: {
		[getProducts.fulfilled]: (state, action) => {
			state.products = action.payload;
		},
		[getCollections.fulfilled]: (state, action) => {
			state.collections = action.payload;
		},
	},
});

export const { resetState } = subscriptionProductsSlice.actions;
export default subscriptionProductsSlice.reducer;
